<template>
  <v-dialog
    v-model="dialog"
    max-width="440"
    overlay-opacity="0.8"
    :persistent="loading"
  >
    <v-card class="rounded-xl">
      <v-card-title class="text-body-1 font-weight-bold">
        {{ blocking ? "Bloquear cliente" : "Desbloquear cliente" }}
      </v-card-title>
      <v-card-text>
        <p class="mb-2">
          Confirma que deseja {{ blocking ? "bloquear" : "desbloquear" }}
          <strong>{{ user?.name || "este cliente" }}</strong>?
        </p>
        <p class="mb-0 text-caption">
          {{
            blocking
              ? "A conta fica inativa até ser desbloqueada."
              : "A conta volta a ficar ativa."
          }}
        </p>
        <v-alert v-if="error" type="error" dense text class="mt-4 mb-0">
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn text :disabled="loading" @click="close">Cancelar</v-btn>
        <v-spacer />
        <v-btn
          depressed
          :color="blocking ? 'error' : 'success'"
          :loading="loading"
          @click="confirm"
        >
          {{ blocking ? "Bloquear" : "Desbloquear" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import USERS from "@/services/ultimate/users";

export default {
  name: "UserActiveModal",
  data: () => ({
    dialog: false,
    loading: false,
    error: null,
    user: null,
  }),
  computed: {
    blocking() {
      return this.user?.active !== false;
    },
  },
  methods: {
    open(user) {
      this.user = user;
      this.error = null;
      this.loading = false;
      this.dialog = true;
    },
    close() {
      if (this.loading) return;
      this.dialog = false;
    },
    async confirm() {
      if (!this.user?.id || this.loading) return;
      const active = !this.blocking;
      this.loading = true;
      this.error = null;
      try {
        await USERS.setUserActive(this.user.id, active);
        this.loading = false;
        this.dialog = false;
        this.$emit("saved");
      } catch (error) {
        this.error =
          error.message ||
          (this.blocking
            ? "Erro ao bloquear o cliente"
            : "Erro ao desbloquear o cliente");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
